import React from 'react';
import { NavDropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { AnyType } from '../interfaces';
import { AppRootState, logout, navigateToSettings } from '../redux';
import { renderTenancyLinksAsNavItems } from '../utils';

export const UserMenu = () => {
  const dispatch = useDispatch();
  const session = useSelector((state: AppRootState) => state.auth.session);
  const adminMenu = useSelector(
    (state: AppRootState) => (((state.app.entities?.menus as AnyType) ?? {})['user.admin'] as AnyType)?.data?.links
  );
  const generalMenu = useSelector(
    (state: AppRootState) => (((state.app.entities?.menus as AnyType) ?? {})['user.general'] as AnyType)?.data?.links
  );
  const isAdmin = Boolean(useSelector((state: AppRootState) => state.auth?.isAdmin));

  const renderUserTitle = () => {
    if (!session) return '';

    return (
      <span className='text-capitalize text-truncate d-inline-block user-menu-section' style={{ maxWidth: '200px' }}>
        <span className='user-menu-name'>
          {session?.user?.name?.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}
        </span>
        <br />
        <span className='user-menu-address'>{session?.orgDetails?.organizationName}</span>
      </span>
    );
  };
  return (
    <NavDropdown
      id='user-menu-dropdown'
      title={renderUserTitle()}
      className='cmx__hcp-user-nav w-auto mt-2 adjust-dropdown'
      data-testid='cmx__usermenu'>
      <NavDropdown.Item data-testid='cmx__my-account' eventKey='account' onClick={() => dispatch(navigateToSettings())}>
        <i className='fa-light fa-user-gear'></i>
        <NavDropdown.ItemText>My Account</NavDropdown.ItemText>
      </NavDropdown.Item>
      {isAdmin && (
        <NavDropdown.Item className=''>
          <i className='fa-regular fa-laptop-medical'></i>
          {renderTenancyLinksAsNavItems(dispatch, adminMenu)}
        </NavDropdown.Item>
      )}
      {renderTenancyLinksAsNavItems(dispatch, generalMenu)}
    </NavDropdown>
  );
};
